import api from "@/api/api";

export interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  image: string;
  reference?: string;
  image_name?: string;
  product_image_id?: number;
}

export interface ProductImage {
  id: number;
  // Ajoutez les propriétés selon votre modèle
}

class ProductService {
  async getProducts(): Promise<Product[]> {
    const response = await api.get("/products");
    return response.data;
  }

  async getProductById(id: number): Promise<Product> {
    const response = await api.get(`/products/${id}`);
    return response.data;
  }

  async getProductImages(): Promise<ProductImage[]> {
    const response = await api.get("/product_images");
    return response.data;
  }
}

export default new ProductService();
